// Textos de Salud operativa y Auditoría: traducen los códigos que manda el backend.
import { auditActionText as staffActionText } from '../staff/staffText';

const JOB_STATE = {
  OK: { label: 'Bien', color: 'success' },
  PARTIAL: { label: 'Con fallos', color: 'warning' },
  FAILED: { label: 'Falló', color: 'error' },
  NEVER: { label: 'Sin datos', color: 'default' },
};

/** Estado visible de un job: { label, color }. Un job atrasado nunca figura como "Bien". */
export const jobStateInfo = (job) => {
  if (job.late && job.state === 'OK') return { label: 'Atrasado', color: 'warning' };
  return JOB_STATE[job.state] || JOB_STATE.NEVER;
};

/** Un job necesita atención si falló, terminó con fallos o dejó de correr. Sin datos no cuenta (todavía no corrió). */
export const jobNeedsAttention = (job) => job.state === 'FAILED' || job.state === 'PARTIAL' || job.late === true;

/** 1250 -> "1,3 s"; 420 -> "420 ms"; 250000 -> "4 min". */
export const formatDuration = (ms) => {
  const n = Number(ms);
  if (!Number.isFinite(n) || n < 0) return '-';
  if (n < 1000) return `${Math.round(n)} ms`;
  if (n < 60000) return `${(Math.round(n / 100) / 10).toString().replace('.', ',')} s`;
  return `${Math.round(n / 60000)} min`;
};

const AUDIT_ACTIONS = {
  LOGIN_FAILED: 'Login fallido',
  LOGIN_UNKNOWN_DOMAIN: 'Login con dominio desconocido',
  LOGIN_BLOCKED: 'Intento bloqueado por exceso de fallos',
  CORE_LOGIN_FAILED: 'Login fallido en el admin',
  CORE_LOGIN_OK: 'Acceso al admin',
  COMPANY_CREATED: 'Empresa creada',
  COMPANY_UPDATED: 'Empresa modificada',
  COMPANY_DELETED: 'Empresa eliminada',
  ADMIN_CREDENTIALS_VIEWED: 'Credenciales del administrador consultadas',
  PLUGIN_CHANGED: 'Función activada o desactivada',
  CORE_SETTINGS_CHANGED: 'Configuración del sistema modificada',
};

export const auditEventText = (action) => AUDIT_ACTIONS[action] || action;

/** Acción de una cuenta de personal (STAFF_CREATED...) en texto. */
export const staffAuditText = (action) => staffActionText(action);

export const AUDIT_CATEGORIES = [
  { value: 'ALL', label: 'Todo' },
  { value: 'SECURITY', label: 'Seguridad' },
  { value: 'CONFIG', label: 'Cambios de configuración' },
  { value: 'STAFF', label: 'Personal del admin' },
];

export const categoryColor = (category) => (category === 'SECURITY' ? 'warning' : category === 'CONFIG' ? 'info' : 'default');

/** Los tabs en vivo no admiten más de 90 días. */
export const MAX_LIVE_DAYS = 90;
export const clampLiveDays = (days) => Math.min(days, MAX_LIVE_DAYS);

/** Texto de una lista de errores 5xx: "0,3 %" o "-" si no hubo pedidos. */
export const errorRateText = (errors, requests) => (requests > 0 ? `${((errors / requests) * 100).toFixed(1).replace('.', ',')} %` : '-');

/** Casos de la conciliación de Mercado Pago que muestra la tarjeta especial (null si el job no trajo desglose). */
export const reconcileCases = (details) => {
  if (!details || typeof details !== 'object') return null;
  return {
    ambiguous: Number(details.ambiguous) || 0,
    superseded: Number(details.superseded) || 0,
    rateLimited: Number(details.rateLimited) || 0,
    accountErrors: Number(details.accountErrors) || 0,
    sweepErrors: Number(details.sweepErrors) || 0,
    checked: Number(details.checked) || 0,
  };
};
